import { create } from "zustand";

// Actor Info/Data
export const useActorProfileStore = create((set, get) => ({
	actorDetail: [],
	setActorProfile: (data) => set({ actorDetail: data }),
}));

